import { useEffect, useState } from 'react';
import AuthHeader from './AuthHeader';
import AuthForm from './AuthForm';
import usePostData from 'hooks/usePostData';

import translating from '../translate.json';

const ChangePasswordForm = () => {
  const { res, error, postData } = usePostData();
  const [errFun, setErrFun] = useState();
  let token;

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    token = params.get('p');
  }, []);

  function parseJwt(t) {
    var base64Url = t.split('.')[1];
    var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    var jsonPayload = decodeURIComponent(
      window
        .atob(base64)
        .split('')
        .map(function (c) {
          return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
        })
        .join('')
    );

    return JSON.parse(jsonPayload);
  }

  useEffect(() => {
    if (error) {
      errFun?.set('apiError', {
        type: 'string',
        message: error.apiError
      });
    } else if (res && res.affected === 1) window.location.href = '/login';
  }, [res, error]);

  const onSubmit = (data, setError) => {
    setErrFun({ set: setError });
    let copyData = { ...data };
    copyData.email =
      sessionStorage.getItem('emailMvmt') || parseJwt(token)?.username;
    copyData.jwtToken = token;
    postData('auth/SetNewPassword', copyData, 'patch');
  };

  const fields = [
    {
      name: 'password',
      label: translating.password,
      placeholder: translating.typePassword,
      pattern: {
        value: /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{8,}$/,
        message: translating.passwordFormatErrMsg
      }
    },
    {
      name: 'confirmPassword',
      label: translating.passwordAgain,
      placeholder: translating.typePassword,
      errMsg: translating.passwordNotMatch
    }
  ];

  return (
    <div className="forgot-password-form">
      <AuthHeader
        title={translating.changePasswordTitle}
        description={translating.changePasswordDescription}
      ></AuthHeader>
      <AuthForm
        fields={fields}
        handleClickSubmit={onSubmit}
        submitTxt={translating.updatepassword}
      ></AuthForm>
    </div>
  );
};

export default ChangePasswordForm;
